module.exports = __webpack_public_path__ + "static/media/level-a-book-desktop.fb9c5643.svg";